/**
 * Training status for Projects with Machine Learning / AI
 */
export enum TrainingStatus {
    MODELS_ONLY = "MODELS_ONLY",
    DATA_AND_MODELS = "DATA_AND_MODELS",
}

export const trainingStatusDisplayValues = ["Models Only", "Data and Models"]
